import styled from 'styled-components';

import { TextButton as TextButtonComponent } from '@xingternal/button';
import { mediaConfined } from '@xingternal/layout-tokens';
import { Menu as MenuComponent, SingleSelect as SingleSelectComponent } from '@xingternal/menu';

export const TextButton = styled(TextButtonComponent)`
  align-self: flex-start;
`;

export const Menu = styled(MenuComponent)`
  @media ${mediaConfined} {
    width: 290px;
  }
`;

export const SingleSelect = styled(SingleSelectComponent)`
  div {
    width: 100%;
    justify-content: space-between;
  }
`;
